module.exports = __webpack_public_path__ + "img/videoCoverImg.f785fc71.jpg";